<template>
  <table class="table table-hover w-100">
    <thead class="thead-light">
      <tr>
        <th class="text-center">{{ $tc("actions.name", 2) }}</th>
        <th class="text-center">{{ $t("match_rules_card.apply_to") }}</th>
        <th class="text-center">{{ $t("match_rules_card.on_param") }}</th>
        <th class="text-center">{{ $tc("match_rules_card.with_values",2) }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index" v-if="shouldRender(item)">
        <td class="text-center">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <b-dropdown-item @click="$emit('edit', index)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50 text-capitalize">{{ $t("actions.edit") }}</span>
            </b-dropdown-item>
            <b-dropdown-item @click="$emit('delete', index)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">{{ $t("actions.delete") }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </td>
        <td class="text-center">{{ translateAction(item.action) }}</td>
        <td class="text-center">{{ extractField(item.field) }}</td>
        <td class="text-center">
          {{ Array.isArray(item.value) ? item.value.join(", ") : item.value }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        { key: 'actions', label: this.$t('actions.name'), class: 'text-center' },
        { key: 'action', label: this.$t('match_rules_card.apply_to'), class: 'text-center' },
        { key: 'field', label: this.$t('match_rules_card.on_param'), class: 'text-center' },
        { key: 'value', label: this.$t('match_rules_card.with_values'), class: 'text-center' },
      ];
    },
  },
  methods: {
    translateAction(action) {
      return this.$t(`match_rules_action.${action}`) || action;
    },
    extractField(field) {
      const match = field.match(/\[(.*?)\]/);
      return match ? match[1].replace(/_/g, ' ') : field.replace(/_/g, ' ');
    },
    shouldRender(item) {
      return item.field !== 'provider' && item.field !== 'camera' && item.field !== 'alarmType';
    },
  },
};
</script>